import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import AuthorLink from 'app/components/bibs/shared/AuthorLink';
import './BibAuthors.scss';

const { composeAuthorClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

const handleClick = () => {
  sendAnalyticsEvents(
    composeAuthorClickEvent({
      containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM
    })
  );
};

export class BibAuthors extends React.PureComponent {
  render() {
    const authors = this.props.catalogBib.getIn(['brief', 'creators'], Immutable.List());

    return (
      <div className="cp-bib-authors authors-wrapper">
        <AuthorLink
          authors={authors}
          renderAsLink={this.props.renderAsLink}
          truncateCount={this.props.truncateCount}
          handleClick={handleClick}
        />
      </div>
    );
  }
}

BibAuthors.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  truncateCount: PropTypes.number,
  renderAsLink: PropTypes.bool
};

export default BibAuthors;
